import React, { Component } from 'react';
import { Modal, Button, Input, message, Upload, Radio, InputNumber } from 'antd';
import $, { xToken } from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ExportUtil from '../../../common/ExportUtil';

const { TextArea } = Input;
const RadioGroup = Radio.Group;

const Config = {
    'refuse': {
        title: '拒绝原因',
        textAreaTitle: '拒绝原因',
        url: API_URL.evaluate.auditEvaluateRecord,
    },
    'repulse': {
        title: '商务建议',
        textAreaTitle: '建议说明',
        url1: API_URL.evaluate.repulseEvaluateRecord,
        url2: API_URL.evaluate.businessReviewTotalPrice,
    },
}

class OperateReason extends Component {
    state = {
        data: [],
        params: {},
        visible: false,
        loading: false,
        type: 'refuse',
        fileList: [],
        calculating: false,
    }

    show = (record = {}, type) => {
        this.setState({
            params: {...record},
            visible: true,
            type,
            calculating: false,
        });
    }

    hide = () => {
        this.setState({
            data: [],
            params: {},
            visible: false,
            loading: false,
            type: 'refuse',
            fileList: [],
            calculating: false,
        });
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        // 金额发生变化时，清空GP%
        if (key === 'bindTotalPrice' || key === 'nonBindTotalPrice') {
            params.gpPercent = null;
        }
        this.setState({ params });
    }

    beforeUpload = (file) => {
        this.setState({
            fileList:[
                ...this.state.fileList,
                file,
            ]
        })
        return false
    }

    handleRemove = (file) => {
        const { fileList } = this.state;
        const index = fileList.indexOf(file);
        const newFileList = fileList.slice();
        newFileList.splice(index, 1);
        this.setState({fileList: newFileList});
    }
    // 确定按钮是否禁用（当选择商务重新确认总价且GP%为空时禁用）
    isConfirmDisabled = () => {
        const { type, params } = this.state;
        const { constructType, gpPercent } = params;
        if (type === 'repulse' && constructType === 'REAPPLY') {
            return gpPercent === undefined || gpPercent === null || gpPercent === '';
        }
        return false;
    }

    // 计算GP%
    calculateGpPercent = () => {
        const { params } = this.state;
        const { evaluateRecordId, bindTotalPrice, nonBindTotalPrice, serveFeeType } = params;
        const isBind = serveFeeType === "BIND";
        const isNonBind = serveFeeType === "NON_BIND";
        const isBindAndNonBind = serveFeeType === "NON_BIND,BIND";
        if ((isBind && !bindTotalPrice) || (isNonBind && !nonBindTotalPrice)) {
            return message.warning('请先输入金额');
        }
        if (isBindAndNonBind && (!nonBindTotalPrice || !bindTotalPrice)) {
            return message.warning('请先输入金额');
        }
        this.setState({ calculating: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.getGpPercentByTotalPrice,
            data: {
                evaluateRecordId,
                blindTotalPrice: bindTotalPrice,
                nonBlindTotalPrice: nonBindTotalPrice,
            },
            dataType: 'json',
            doneResult: res => {
                const { params } = this.state;
                params.gpPercent = res.gpPercent;
                this.setState({ params, calculating: false });
            },
            errorResult: () => {
                this.setState({ calculating: false });
            }
        };
        $.sendRequest(options);
    }

    // 商务建议-查询GP%测算值
    getGpPercentByTotalPrice = () => {
        const { params } = this.state;
        const { evaluateRecordId, bindTotalPrice, nonBindTotalPrice, serveFeeType } = params;
        const isBind = serveFeeType === "BIND";  //项目包含盲态服务
        const isNonBind = serveFeeType === "NON_BIND";  //项目包含非盲服务
        const isBindAndNonBind = serveFeeType === "NON_BIND,BIND";  //项目包含盲态服务和非盲服务
        if ((isBind && !bindTotalPrice) || (isNonBind && !nonBindTotalPrice)) {
            return ;
        }
        if (isBindAndNonBind && (!nonBindTotalPrice || !bindTotalPrice)) {
            return ;
        }
        const options = {
            method: 'POST',
            url: API_URL.evaluate.getGpPercentByTotalPrice,
            data: {
                evaluateRecordId,
                blindTotalPrice: bindTotalPrice,
                nonBlindTotalPrice: nonBindTotalPrice,
            },
            dataType: 'json',
            doneResult: res => {
                params.gpPercent = res.gpPercent;
                this.setState({
                    params,
                })
            }
        };
        $.sendRequest(options);
    }

    submit = () => {
        const { params, type, fileList } = this.state;
        const {
            remark,
            evaluateRecordId,
            constructType,
            serveFeeType,
            bindTotalPrice,
            nonBindTotalPrice,
            gpPercent,
        } = params;

        if (!remark) {
            return message.warning(`请输入${Config[type].textAreaTitle}`)
        }
        // 所有校验通过后再设置 loading，防止校验失败后按钮卡住
        if (type === 'repulse') {
            if (!constructType) {
                return message.warning('请输入建议节点')
            }
            if (constructType == 'REAPPLY' && !bindTotalPrice && !nonBindTotalPrice) {
                return message.warning('请输入商务建议总价金额(含税)/人民币');
            }
            if (serveFeeType === "NON_BIND,BIND" && constructType == 'REAPPLY' && !bindTotalPrice) {
                return message.warning('请输入盲态服务商务建议总价金额(含税)/人民币');
            }
            if (serveFeeType === "NON_BIND,BIND" && constructType == 'REAPPLY' && !nonBindTotalPrice) {
                return message.warning('请输入非盲服务商务建议总价金额(含税)/人民币');
            }
            if (constructType == 'REAPPLY' && fileList.length == 0) {
                return message.warning("请选择附件")
            }
            if (constructType == 'REAPPLY' && (gpPercent === undefined || gpPercent === null || gpPercent === '')) {
                return message.warning('请先计算GP%');
            }
        }
        this.setState({ loading: true });
        if (type === 'refuse') {
            const options = {
                method: 'POST',
                url: Config[type].url,
                data: {
                    remark,
                    evaluateRecordId,
                    approvalStatus: 'REFUSE',
                },
                dataType: 'json',
                doneResult: res => {
                    message.success(res.success);
                    this.hide();
                    this.props.loadData();
                }
            };
            $.sendRequest(options);
        } else {
            const fromData = new FormData();
            fileList.map((file, index) => {
                fromData.append(`files[${index}]`, file)
            });
            fromData.append('evaluateRecordId', evaluateRecordId);
            fromData.append('remark', remark);
            fromData.append('constructType', constructType);
            fromData.append('serveFeeType', serveFeeType);
            fromData.append('curUserId', sessionStorage.userId);
            fromData.append('curEmployeeCode', sessionStorage.curEmployeeCode || '');
            fromData.append('gpPercent', gpPercent);
            if (bindTotalPrice) fromData.append('blindTotalPrice', bindTotalPrice);
            if (nonBindTotalPrice) fromData.append('nonBlindTotalPrice', nonBindTotalPrice);
            const url = constructType == 'RESTART' ? Config[type].url1 : Config[type].url2;
            fetch(url,{
                method: 'post',
                body: fromData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    ...xToken,
                }
            }).then(res => {
                if (res.ok) {
                    return res.json();
                }
            }).then(data => {
                if (data.error) {
                    message.error(data.error);
                    this.setState({ loading: false });
                } else {
                    message.success(data.success);
                    this.hide();
                    this.props.loadData();
                }
            });
        }
    }

    downLoadFile = (e, fileMetaId) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId }, null, url);
    }

    render() {
        const { visible, params, type, fileList, loading } = this.state;
        const { 
            remark, 
            evaluateRecordId, 
            constructType, 
            evaluateStatus, 
            bindTotalPrice, 
            nonBindTotalPrice, 
            serveFeeType, 
            gpPercent,
        } = params;
        const isBind = serveFeeType === "BIND";  //项目包含盲态服务
        const isNonBind = serveFeeType === "NON_BIND";  //项目包含非盲服务
        const isBindAndNonBind = serveFeeType === "NON_BIND,BIND";  //项目包含盲态服务和非盲服务
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <Modal
                title={`${Config[type].title}`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="preview-modal"
                maskClosable={false}
                confirmLoading={loading}
                okButtonProps={{ disabled: this.isConfirmDisabled() }}
                width="700px"
            >
                <div className="modal-content" style={{ padding: '20px 30px' }}>
                        <ul className="modal-list">
                            {
                                type == 'repulse' && 
                                    <li className="modal-item">
                                        <div className="item-left" style={{width: '30%'}}>{asterisk}建议节点：</div>
                                        <div className="item-right" style={{width: '70%'}}>
                                            <RadioGroup 
                                                value={constructType}
                                                onChange={e => this.handleChange(e.target.value, 'constructType')} 
                                            >
                                                <Radio 
                                                    value='RESTART' 
                                                    style={{ marginRight: 10 }}
                                                >
                                                    PM重新评估
                                                </Radio>
                                                {
                                                    (evaluateStatus == 'STATE_APPROVED' || evaluateStatus == 'STATE_CONFIRM') && <Radio 
                                                        value='REAPPLY'
                                                        style={{ marginRight: 10 }} 
                                                    >
                                                        商务重新确认总价
                                                    </Radio>
                                                }
                                            </RadioGroup>
                                        </div>
                                    </li>
                            }
                            {
                                (constructType == 'REAPPLY' && (isBind)) &&
                                <li className="modal-item">
                                    <div className="item-left" style={{width: '30%'}}>{asterisk}商务建议总价金额（含税）/人民币：</div>
                                    <div className="item-right" style={{width: '70%'}}>
                                        <InputNumber
                                            placeholder='请输入'
                                            step={0.01}
                                            min={0}
                                            precision={2}
                                            style={{ width: 300 }}
                                            disabled={this.state.calculating}
                                            value={bindTotalPrice}
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                            onChange={value => this.handleChange(value, 'bindTotalPrice')}
                                        />
                                    </div>
                                </li>
                            }
                            {
                                (constructType == 'REAPPLY' && (isNonBind)) &&
                                <li className="modal-item">
                                    <div className="item-left" style={{width: '30%'}}>{asterisk}商务建议总价金额（含税）/人民币：</div>
                                    <div className="item-right" style={{width: '70%'}}>
                                        <InputNumber
                                            placeholder='请输入'
                                            step={0.01}
                                            min={0}
                                            precision={2}
                                            style={{ width: 300 }}
                                            disabled={this.state.calculating}
                                            value={nonBindTotalPrice}
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                            onChange={value => this.handleChange(value, 'nonBindTotalPrice')}
                                        />
                                    </div>
                                </li>
                            }
                            {
                                (constructType == 'REAPPLY' && isBindAndNonBind) &&
                                <li className="modal-item">
                                    <div className="item-left" style={{width: '30%'}}>{asterisk}盲态服务商务建议总价金额（含税）/人民币：</div>
                                    <div className="item-right" style={{width: '70%'}}>
                                        <InputNumber
                                            placeholder='请输入'
                                            step={0.01}
                                            min={0}
                                            precision={2}
                                            style={{ width: 300 }}
                                            disabled={this.state.calculating}
                                            value={bindTotalPrice}
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                            onChange={value => this.handleChange(value, 'bindTotalPrice')}
                                        />
                                    </div>
                                </li>
                            }
                            {
                                (constructType == 'REAPPLY' && isBindAndNonBind) &&
                                <li className="modal-item">
                                    <div className="item-left" style={{width: '30%'}}>{asterisk}非盲服务商务建议总价金额（含税）/人民币：</div>
                                    <div className="item-right" style={{width: '70%'}}>
                                        <InputNumber
                                            placeholder='请输入'
                                            step={0.01}
                                            min={0}
                                            precision={2}
                                            style={{ width: 300 }}
                                            disabled={this.state.calculating}
                                            value={nonBindTotalPrice}
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                            onChange={value => this.handleChange(value, 'nonBindTotalPrice')}
                                        />
                                    </div>
                                </li>
                            }
                            {
                                constructType == 'REAPPLY' &&
                                <li className="modal-item">
                                    <div className="item-left" style={{width: '30%'}}>GP%</div>
                                    <div className="item-right" style={{width: '70%'}}>
                                        {gpPercent !== undefined && gpPercent !== null ? gpPercent + '%' : ''}
                                        <Button
                                            type="primary"
                                            size="small"
                                            style={{ marginLeft: 40 }}
                                            loading={this.state.calculating}
                                            onClick={this.calculateGpPercent}
                                        >计算GP%</Button>
                                    </div>
                                </li>
                            }
                            <li className="modal-item">
                                <div className="item-left" style={{width: '30%'}}>{asterisk}{`${Config[type].textAreaTitle} :`}</div>
                                <div className="item-right" style={{width: '70%'}}>
                                    <TextArea
                                        placeholder='请输入'
                                        style={{ width: 300 }}
                                        rows={4}
                                        value={remark}
                                        onChange={e => this.handleChange(e.target.value, 'remark')}
                                    />
                                </div>
                            </li>
                            {
                                type == 'repulse' && <li className="modal-item">
                                    <div className="item-left" style={{width: '30%'}}>
                                        {constructType == 'REAPPLY' && asterisk}附件：
                                    </div>
                                    <div className="item-right" style={{width: '70%'}}>
                                    <Upload
                                        action={API_URL.evaluate.uploadEnclosureFile}
                                        data={{
                                            relateId: evaluateRecordId,
                                            curUserId: sessionStorage.userId,
                                            curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                            uploadType: 'EVALUATE_RECORD_CUSTOMER_FILE',
                                        }}
                                        fileList={fileList}
                                        beforeUpload={this.beforeUpload}
                                        onRemove={this.handleRemove}
                                        downLoadFile={this.downLoadFile}
                                        headers={xToken}
                                    >
                                        <Button style={{ width: 80 }}>选择文件</Button>
                                    </Upload>
                                    </div>
                                </li>
                            }
                        </ul>
                    </div>
            </Modal>
        );
    }
}

export default OperateReason;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/OperateReason.js